// extracted by mini-css-extract-plugin
module.exports = {"bs-header":"bs-header_1s_Iv","divider":"divider_1ezy-"};